import styled from 'styled-components';
import DefaultAddButton from 'components/Buttons/AddButton';

// TODO: TFR-49 split components into two or more different logical components
export const ActionCard = styled.div`
  width: 100%;
  background: ${({ theme }) => theme.colors.white};
  padding: 1rem;
  border-radius: 1rem;
`;

// TODO: TFR-46 remove imports in styled.ts if you do not add styles to component
export const AddButton = styled(DefaultAddButton)``;
